import { render, staticRenderFns } from "./EditWeightedScorePage.vue?vue&type=template&id=2a720d74"
import script from "./EditWeightedScorePage.vue?vue&type=script&lang=ts"
export * from "./EditWeightedScorePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports